import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "us-west-2",
    aws_cognito_identity_pool_id: "us-west-2:a7fb8971-1b4a-4dc8-81cb-581369350bd3",
    aws_user_pools_id: "us-west-2_EN98EkKGr",
    aws_user_pools_web_client_id: "3qagnmehnut6anet505l35buec",
    Auth: {
      identityPoolId: "us-west-2:a7fb8971-1b4a-4dc8-81cb-581369350bd3",
      region: "us-west-2",
      userPoolId: "us-west-2_EN98EkKGr",
      userPoolWebClientId: "3qagnmehnut6anet505l35buec",
    },
    oauth: {
      domain: "whs-safer-prod-latam.auth.us-west-2.amazoncognito.com",
      redirectSignIn: "https://prod.latam.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.latam.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve prod to "test".
  const stage = "prod".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
